import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetSalaryRisk = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_SALARY_RISK_DETAILS, token);
  return res;
};

export const GetSalaryRiskDetails = async (salaryRiskId) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(
    Url.GET_SALARY_RISK_DETAILS_BY_ID + salaryRiskId,
    token
  );
  return res;
};

export const AddSalaryRisk = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_SALARY_RISK, payload, token);
  return res;
};

export const UpdateSalaryRisk = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.PUT(Url.UPDATE_SALARY_RISK, payload, token);
  return res;
};

export const DeleteSalaryRisk = async (id) => {
  const token = localStorage.getItem("token");
  let res = await Services.DELETE(Url.DELETE_SALARY_RISK + id, id, token);
  return res;
};
